import { Component, Input } from '@angular/core';

import { IconStyleEnum } from './enums/icon-style.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { IconTypeEnum } from './enums/icon-type.enum';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() public ariaLabel?: string;
  @Input() public name = VtmnPlayIconTypeEnum.ArrowDown || IconTypeEnum;
  @Input() public style = IconStyleEnum.LINE;

  public get ariaHidden(): boolean {
    return !this.ariaLabel;
  }

  public get className(): string {
    return `vtmx-${this.name}-${this.style}`;
  }
}
